var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('title-view',[_vm._v("מסך היסטורית משחקים\n\t")]),_c('row',[_c('c-col',[_c('game-logs-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }